<template>
  <div class="landing-page-wrapper">
    <iframe
      src="/static/landing_page.html"
      frameborder="0"
      class="landing-iframe"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: "LandingPage",
  data() {
    return {};
  },
};
</script>

<style scoped>
.landing-page-wrapper {
  width: 100vw;
  min-height: 100vh;
}

.landing-iframe {
  width: 100%;
  min-height: 100vh;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/views/LandingPage/index.vue